import styled, { css } from 'styled-components';
import { HashLink } from 'react-router-hash-link';
import { mobileMediaQuery } from '../../../Theming';

const linkStyle = css`
  margin: 5px 0;
  font-size: 1rem;
  line-height: 1.0625rem;
  margin-bottom: 17px;
  letter-spacing: 0.5px;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledA = styled.a`
  ${linkStyle}
`;

export const StyledHashLink = styled(HashLink)`
  ${linkStyle}
`;

export const Header = styled.h6`
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.875rem;
  text-transform: uppercase;
  margin: 27px 0 55px;

  ${mobileMediaQuery} {
    margin-bottom: 10px;
  }
`;
